import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  Icon,
  SelectableBox,
  Stack,
} from '@openedx/paragon';
import { Check } from '@openedx/paragon/icons';

import TranslationDisclaimer from './TranslationDisclaimer';
import messages from './messages';
import './LanguageSelector.scss';

const LanguageSelector = ({
  selectedIndex,
  setSelectedIndex,
  courseEnabledLanguages,
  originalCourseLanguage,
}) => {
  const { formatMessage } = useIntl();
  const handleChange = (e) => setSelectedIndex(Number(e.target.value));

  return (
    <div className="pgn__card small">
      <SelectableBox.Set
        value={String(selectedIndex)}
        onChange={handleChange}
        name="languages"
        columns={1}
        ariaLabel="language selection"
        className="language-set"
      >
        {courseEnabledLanguages.map(({ code, label, localeName }, index) => (
          <SelectableBox
            key={code}
            value={index}
            aria-label={`${label} radio`}
            className="option shadow-none"
          >
            <Stack gap={3} direction="horizontal">
              {code === originalCourseLanguage ? formatMessage(messages.originalLanguageLabel) : localeName}
              {selectedIndex === index && <Icon src={Check} className="text-success" />}
            </Stack>
          </SelectableBox>
        ))}
      </SelectableBox.Set>
      <div className="p-3">
        <TranslationDisclaimer />
      </div>
    </div>
  );
};

LanguageSelector.propTypes = {
  courseEnabledLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  originalCourseLanguage: PropTypes.string.isRequired,
};

export default LanguageSelector;
